////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const salesControl = {
	getSalesControl: (filters = {}, queryParams = { page: '0', size: '250', sort: 'labelToManufacturer', nameDir: 'asc' }) => ({
		type: ActionsTypes.GET_SALES_CONTROL,
		payload: {
			filters,
			queryParams,
		},
	}),
	getSalesControlSuccess: (data) => ({
		type: ActionsTypes.GET_SALES_CONTROL_SUCCESS,
		payload: {
			data,
		},
	}),
	getSalesControlFailure: (error) => ({
		type: ActionsTypes.GET_SALES_CONTROL_FAILURE,
		payload: {
			error,
		},
	}),
	resetSalesControlItems: () => ({
		type: ActionsTypes.RESET_SALES_CONTROL_ITEMS,
	}),
}

export default salesControl
